import { isString } from 'lodash'

/**
 * Check if given string is a valid ISO time.
 *
 * @param {string} timeString
 * @returns {boolean}
 */
export function isValidISOTime(timeString) {
    // @TODO Refactor this
    return isString(timeString) && /^0[0-9]|1[0-9]|2[0-3]:[0-5][0-9]$/.exec(timeString) !== null
}
